import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter, Handler,HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {chain,ValidatePostalCode} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import translate from "@insite/client-framework/Translate";
import {
    AddressFieldDisplayCollectionModel,
    BaseAddressModel,
    CustomerValidationDto,MelissaRecordModel,
} from "@insite/client-framework/Types/ApiModels";
import { getValidationResult,MelissaApiParameter } from "@MasterBluePrint/Services/MelissaService";
import { enableMelissaAvsSetting } from "@MasterBluePrint/Store/Context/ContextSelector";
import { CustomApplicationState } from "@MasterBluePrint/Store/CustomApplicationState";


export type AddressErrors = SafeDictionary<React.ReactNode>;

type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<AddressErrors>,
    {
        addressErrors: AddressErrors;
    }
>;

export const MelissaValidateAddress: HandlerType = async props => {
    const customApplicationState = props.getState() as CustomApplicationState;
    const byPassAddressValidation = customApplicationState.customCheckoutShippingState.bypassMelissaAddressValidation;
    const enableMelissaAvs = enableMelissaAvsSetting(props.getState())?.enableMelissaAvs;
    const { address1, address2, city, state, postalCode, country, companyName } = props.parameter.address;
    const melissaAddressChangeCodes = ['AC06', 'AC07', 'AC10', 'AC11', 'AC12', 'AC13', 'AC14', 'AC18', 'AC20'];

    if(!enableMelissaAvs){
        return;
    }

    if (byPassAddressValidation){
        return;
    }

    if (!address1 || !city || !state || !postalCode || !country){
        return;
    }

    if (address1 === "" || city === "" || state.abbreviation === "" || postalCode === "" || country.abbreviation === ""){
        return;
    }

    const isCountryUSorCA = country.abbreviation ==="US" || country.abbreviation ==="CA";

    if(!isCountryUSorCA){
        return;
    }

    const melissaApiParameter: MelissaApiParameter = {
        comp: companyName,
        a1: address1,
        a2: address2,
        city,
        state: state?.abbreviation,
        postal: postalCode,
        ctry: country?.abbreviation,
    };
    // make the call to Melissa API
    const result = await getValidationResult(melissaApiParameter);
    result.Records?.forEach((record: MelissaRecordModel) => {
        // look for any Address Error codes (AE)
        // But if code AS17 shows, "No USPS Mail Delivery". Delivery might still be an option for 3rd party carrier, but the address cannot be fully verified.
        if (record.Results.indexOf("AE") >= 0 && record.Results.indexOf("AS01") === -1 && record.Results.indexOf("AS17") === -1) {
            props.addressErrors.address1 = translate("Invalid address");
        }

        else if (melissaAddressChangeCodes.some(changeCode => record.Results.indexOf(changeCode) >= 0)) {
            props.addressErrors.address1 = translate("Invalid address");
        }

        if (record.Results.indexOf("AC01") >= 0) {
            props.addressErrors.postalCode = translate("Invalid zipcode");
        }

        if (record.Results.indexOf("AC03") >= 0) {
            props.addressErrors.city = translate("Invalid city");
        }

        if(Object.keys(props.addressErrors).length > 0) {
            props.addressErrors.isMelissaValidationError = true;
        }
    });
};

addToChainAfter(chain, ValidatePostalCode, MelissaValidateAddress);